import { render, staticRenderFns } from "./LinkedIconCard.vue?vue&type=template&id=645030bb"
import script from "./LinkedIconCard.vue?vue&type=script&lang=js"
export * from "./LinkedIconCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports